module.exports = __webpack_public_path__ + "static/media/lb.712c585e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/lb.png
// module id = 13571
// module chunks = 0